export const getUrlParams = (name) => {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
}
export function replaceParamVal(url,paramName,replaceVal) {
	var oUrl = url.toString();
	var re=eval('/('+ paramName+'=)([^&]*)/gi');
	var nUrl = oUrl.replace(re,paramName+'='+replaceVal);
	return nUrl;
  }
  
export const getBrowserUserAgent = () => {
    var u = navigator.userAgent,
			app = navigator.appVersion;
		return {
			trident: u.indexOf('Trident') > -1, //IE内核
			presto: u.indexOf('Presto') > -1, //opera内核
			webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
			gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
			mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
			ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
			android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
			iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
			iPad: u.indexOf('iPad') > -1, //是否iPad
			webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
			weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
			qq: u.match(/\sQQ/i) == " qq" ,//是否QQ
			YouRui: u.indexOf('YouRui') > -1, //是否在神光app内部
		};
}

export const connectWebViewJavascriptBridge = (callback) => {
    var userAgent = getBrowserUserAgent();
var dsBridge = require("dsbridge");
	if(userAgent.android) {
		if(window.WebViewJavascriptBridge) {
			callback(WebViewJavascriptBridge)
		} else {
			document.addEventListener(
				'WebViewJavascriptBridgeReady',
				function() {
					callback(WebViewJavascriptBridge)
				},
				false
			);
		}
	} else if(userAgent.ios) {
				
			if (window.WebViewJavascriptBridge) {
				
				return callback(WebViewJavascriptBridge); 
			}
			
			if (window.WVJBCallbacks) {
			
				return window.WVJBCallbacks.push(callback); }
			
		window.WVJBCallbacks = [callback];
	
		var WVJBIframe = document.createElement('iframe');
		WVJBIframe.style.display = 'none';
		WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';
		document.documentElement.appendChild(WVJBIframe);
		setTimeout(function() {
			document.documentElement.removeChild(WVJBIframe)
		}, 0)
	}

}
// export function connectWebViewJavascriptBridge(callback) {
// 	var userAgent = getBrowserUserAgent();
var dsBridge = require("dsbridge");
// 	if(userAgent.android) {
// 		if(window.WebViewJavascriptBridge) {
// 			callback(WebViewJavascriptBridge)
// 		} else {
// 			document.addEventListener(
// 				'WebViewJavascriptBridgeReady',
// 				function() {
// 					callback(WebViewJavascriptBridge)
// 				},
// 				false
// 			);
// 		}
// 	} else if(userAgent.ios) {
		
// 		if(window.WVJBCallbacks) {
// 			return window.WVJBCallbacks.push(callback);
// 		}
// 		window.WVJBCallbacks = [callback];
// 		var WVJBIframe = document.createElement('iframe');
// 		WVJBIframe.style.display = 'none';
// 		WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';
// 		document.documentElement.appendChild(WVJBIframe);
// 		setTimeout(function() {
// 			document.documentElement.removeChild(WVJBIframe)
// 		}, 0)
// 	}

// }